<template>
  <div class="page-content">
    <div class="page-content-table">
      <div class="page-content-head">
        <div class="table-td vertical1">序号</div>
        <div class="table-td vertical2">商品名称</div>
        <div class="table-td vertical3">
          <div style="display: inline-block;width: 150px;text-align: center;">生产日期</div>
          <div style="display: inline-block;width: calc(100% - 150px);"></div>
        </div>
        <div class="table-td vertical4">有效期至</div>
        <div class="table-td vertical5">
          <div>完成数量</div>
          <div class="table-td-second">(正常品)</div>
        </div>
        <div class="table-td vertical6">
          <div>完成数量</div>
          <div class="table-td-second">(破损品)</div>
        </div>
        <div class="table-td vertical7">
          <div>数量</div>
          <div class="table-td-second">(正常品)</div>
        </div>
        <div class="table-td vertical8">
          <div>数量</div>
          <div class="table-td-second">(破损品)</div>
        </div>
      </div>
      <el-scrollbar wrap-class="scrollbar-wrapper" class="page-content-body">
        <div
          v-for="(item, index) in productionDateDetailList"
          :key="index"
          class="page-content-body-list"
        >
          <div
            v-for="(citem, cindex) in item.batchList"
            :key="cindex"
            class="page-content-body-item"
          >
            <div class="table-td vertical1">
              <span v-if="cindex == 0">{{ index + 1 }}</span>
            </div>
            <div class="table-td vertical2 text-one">
              <span v-if="cindex == 0">{{ item.name }}</span>
            </div>
            <div class="table-td vertical3">
              <div v-if="status == 0" style="width: 100%;display: flex;">
                <div style="display: inline-block;width: 150px;text-align: center;">
                  <el-date-picker
                    v-model="citem.ytgbProductionTime"
                    class="date-select"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择"
                    :picker-options="pickerOptions"
                    @change="selDate($event, index, cindex, item.expDays)"
                  ></el-date-picker>
                </div>
                <div style="display: inline-block;width: calc(100% - 150px);">
                  <span
                    v-if="cindex == 0"
                    style="display: inline-block;color: #409eff;cursor:pointer;"
                    @click="handleAddDate(index)"
                  >+日期</span>
                  <el-button
                    style="color: red !important;"
                    v-else
                    type="text"
                    icon="el-icon-delete"
                    @click="handleDelDate(index, cindex)"
                  ></el-button>
                </div>
              </div>
              <div v-else>{{citem.ytgbProductionTime}}</div>
            </div>
            <div class="table-td vertical4">
              <span :style="citem.isPastDue ? 'color:red;' : ''" v-if="status == 0">{{ citem.validUntil }}</span>
              <span :style="getValidUntil(citem.ytgbValidityTime).isPastDue ? 'color:red;' : ''" v-else>{{ citem.ytgbValidityTime || '-' }}</span>
              <!-- <span :style="selDate(citem.ytgbProductionTime, index, cindex, item.expDays).isPastDue ? 'color:red;' : ''" v-else>{{ selDate(citem.ytgbProductionTime, index, cindex, item.expDays).d2 }}</span> -->
            </div>
            <div class="table-td vertical5">
              <div v-if="cindex == 0">{{item.actualNum || 0}}{{item.minUnit}}</div>
              <div
                v-if="cindex == 0"
                class="table-td-second"
              >({{ (item.actualNum && item.box) ? Math.floor(item.actualNum / item.box) : 0 }}{{item.maxUnit}}{{ (item.actualNum && item.box) ? item.actualNum % item.box : 0 }}{{item.minUnit}})</div>
            </div>
            <div class="table-td vertical6">
              <div v-if="cindex == 0">{{item.actualWornNum || 0}}{{item.minUnit}}</div>
              <div
                v-if="cindex == 0"
                class="table-td-second"
              >({{ (item.actualWornNum && item.box) ? Math.floor(item.actualWornNum / item.box) : 0 }}{{item.maxUnit}}{{ (item.actualWornNum && item.box) ? item.actualWornNum % item.box : 0 }}{{item.minUnit}})</div>
            </div>
            <div class="table-td vertical7">
              <el-input
                v-if="status == 0"
                v-model="citem.ytgbNormal"
                class="num-input"
                oninput="value=value.replace(/[^\d]/g,'')"
              ></el-input>
              <span v-else>{{ citem.ytgbNormal }}</span>
              <span>{{item.minUnit}}</span>
            </div>
            <div class="table-td vertical8">
              <el-input
                v-if="status == 0"
                v-model="citem.ytgbBroken"
                class="num-input"
                oninput="value=value.replace(/[^\d]/g,'')"
              ></el-input>
              <span v-else>{{ citem.ytgbBroken }}</span>
              <span>{{item.minUnit}}</span>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div>
      <div style="color: 888;font-size: 13px;">备注：开启生产日期管理的商品才需要填生产日期，有效期至红色表示已过期。</div>
      <div style="height: 79px;text-align: center; line-height: 79px;">
        <el-button style="width: 100px;" size="mini" @click="cancle">关闭</el-button>
        <el-button
          v-if="status == 0"
          style="width: 100px;margin-left: 80px;"
          type="primary"
          size="mini"
          @click="submit"
        >保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import rollsHomework from '@/store/rollsHomework/index'
// , SUPPLIERTASKLABLECANCEL
import { GETUNPRODUCTDATEDETAILLIST, GETPRODUCTDATEDETAILLIST, SAVEPRODUCTIONDATECONFIGURATION } from '@/store/rollsHomework/types'
import { parseTime } from '@/utils'
import {CLOSECURRENTTAG} from '@/store/user/types'
let verifyNum = 0
export default {
  name: 'productionDateEntryDetail',
  data () {
    return {
      warehouseCode: '',
      status: '', // 录入状态 0 未 1 已录入
      code: '', // 任务编号
      list: [],
      goodVoList: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  components: {},
  computed: {
    // 列表
    productionDateDetailList () {
      return rollsHomework.state.productionDateDetailList
    },
    rollsHomeworkMark () {
      return rollsHomework.state.rollsHomeworkMark
    }
  },
  watch: {
    rollsHomeworkMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          rollsHomework.state.rollsHomeworkMark = 0
          this.$store.dispatch('tagsView/setBeforePageName', 'productionDateEntry')
          this.$store.dispatch(CLOSECURRENTTAG, '/rollsHomework/productionDateEntry')
        }
      }
    }
  },
  created () {
    this.status = this.$route.params.status
    this.code = this.$route.params.taskCode
    this.warehouseCode = this.$route.warehouseCode
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      let params = {
        taskCode: this.code
      }
      if (this.status === '0') {
        this.$store.dispatch(GETUNPRODUCTDATEDETAILLIST, params)
      } else {
        this.$store.dispatch(GETPRODUCTDATEDETAILLIST, params)
      }
    },
    handleAddDate (idx) {
      let obj = {
        ytgbId: '', // 批次id
        ytgbProductionTime: '', // 生产日期
        ytgbNormal: 0, // 批次正常品
        ytgbBroken: 0, // 批次破损品
        validUntil: ''
      }
      this.productionDateDetailList[idx].batchList.push(obj)
    },
    handleDelDate (idx, cidx) {
      this.productionDateDetailList[idx].batchList.splice(cidx, 1)
    },
    selDate (e, idx, cidx, expDays) {
      let d1 = ''
      let d2 = ''
      let expDate = ''
      // eslint-disable-next-line eqeqeq
      if (e != '' && e != null) {
        let d1Time = e + ' 23:59:59'
        d1 = new Date(d1Time.replace('-', '/')).getTime()
        expDate = 1000 * 60 * 60 * 24 * (expDays || 0)
        d2 = expDays ? parseTime((d1 + expDate), '{y}-{m}-{d}') : '-'
      } else {
        d2 = '-'
      }
      let isPastDue = expDays ? (d1 + expDate) < new Date().getTime() : false
      this.productionDateDetailList[idx].batchList[cidx].validUntil = d2
      this.productionDateDetailList[idx].batchList[cidx].isPastDue = isPastDue
      return {d2, isPastDue}
    },
    getValidUntil (time) {
      let isPastDue = false
      if (time) {
        // let d1Time = e + ' 23:59:59'
        let d1 = new Date(time.replace('-', '/')).getTime()
        isPastDue = d1 < new Date().getTime()
      } else {
        isPastDue = false
      }

      return {isPastDue}
    },
    cancle () {
      rollsHomework.state.rollsHomeworkMark = 1
    },
    submit () {
      let D = this.productionDateDetailList
      verifyNum = 0
      this.coverVerify(D)
    },
    coverVerify (D) {
      if (D[verifyNum].batchList.some(x => !x.ytgbProductionTime)) {
        this.$message({
          message: D[verifyNum].name + '的生产日期为空,请检查是否有未选择生产日期的行列',
          type: 'warning'
        })
        return
      }
      let batchList = D[verifyNum].batchList.filter(function (x) {
        return x.ytgbNormal + x.ytgbBroken !== 0
      })
      let sNormal = 0
      let sBroken = 0
      batchList.forEach(z => {
        sNormal += parseInt(z.ytgbNormal)
        sBroken += parseInt(z.ytgbBroken)
      })
      if (sNormal !== parseInt(D[verifyNum].actualNum)) {
        this.$message({
          message: D[verifyNum].name + '的正常品录入数量≠完成数量(正常品)，保存失败！',
          type: 'warning'
        })
        return
      }
      if (sBroken !== parseInt(D[verifyNum].actualWornNum)) {
        this.$message({
          message: D[verifyNum].name + '的破损品录入数量≠完成数量(破损品)，保存失败！',
          type: 'warning'
        })
        return
      }
      D[verifyNum].batchList = batchList
      this.goodVoList = D
      if ((verifyNum + 1) < D.length) {
        verifyNum++
        this.coverVerify(D)
      } else {
        let params = {
          taskCode: this.code,
          goodVoList: this.goodVoList,
          warehouseCode: this.warehouseCode
        }
        this.$store.dispatch(SAVEPRODUCTIONDATECONFIGURATION, params)
      }
    }
  }
}
</script>
<style>
.page-content-table .scrollbar-wrapper{
  overflow-x: hidden !important;
  margin-bottom: 0 !important;
}
</style>
<style scope>
.page-content{
  position: fixed;
  top: 138px;
  left: 258px;
  background: #fff;
  bottom: 8px;
  right: 8px;
  padding: 20px 15px;
  box-sizing: border-box;
  overflow: auto;
}
.page-content-table{

  width: 100%;
  height: calc(100% - 100px);
}
.page-content-head{
  /* background: #f2f2f2; */
  /* height: 45px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #EBEEF5;
  color: #909399;
  font-weight: 600;
  box-sizing: border-box;
  font-size: 14px;
  width: 100%;
}
.page-content-body{
  color: #606266;
  box-sizing: border-box;
  font-size: 14px;
  height: calc(100% - 70px);
  width: 100%;
}
.page-content-body-list{
  width: 100%;
}
.page-content-body-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-left: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
  border-bottom: 1px solid #EBEEF5;
  box-sizing: border-box;
}
.table-td{
  padding: 12px 10px;
  /* height: 70px; */
  /* box-sizing: border-box; */
  text-overflow: ellipsis;
  vertical-align: middle;
  text-align: center;
  display: table-cell;
  line-height: 46px;
  height: 46px;
  border-right: 1px solid #EBEEF5;
  /* white-space: pre; */
}
.table-td:last-child {
  border-right: none;
}
.vertical1 {
  width: 45px;
}
.vertical2 {
  width: calc(100% - 917px);
  min-width: 100px;
}
.vertical3 {
  display: flex;
  width: 230px;
}
.vertical4 {
  width: 100px;
}
.vertical5 {
  line-height: 23px;
  width: 120px;
}
.vertical6 {
  line-height: 23px;
  width: 120px;
}
.vertical7 {
  line-height: 23px;
  width: 160px;
}
.vertical8 {
  line-height: 23px;
  width: 160px;
}
.page-content-body .vertical7, .page-content-body .vertical8{
  line-height: 46px;
}
.date-select.el-date-editor.el-input{
  width: 140px !important;
}
.num-input.el-input{
  width: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/page/rollsHomework/productionDateEntry/productionDateEntryDetail.vue